import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import HiLowResult from "../../client/tp-studio/tp-result/HiLowResult.jsx";
import HiloRules from "./pop-up/hilo-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function DTVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);

  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});

  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [displayLoader, setDisplayLoader] = useState(true);

  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [b7Val, setB7Val] = useState(0);
  const [b8Val, setB8Val] = useState(0);
  const [b9Val, setB9Val] = useState(0);
  const [b10Val, setB10Val] = useState(0);
  const [b11Val, setB11Val] = useState(0);
  const [b12Val, setB12Val] = useState(0);
  const [b13Val, setB13Val] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const [highBook, setHighBook] = useState(0);
  const [lowBook, setLowBook] = useState(0);
  const [snapBook, setSnapBook] = useState(0);

  const [winnerHigh, setWinnerHigh] = useState(false);
  const [winnerLow, setWinnerLow] = useState(false);
  const [winnerSnap, setWinnerSnap] = useState(false);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastEvtStatusRef = useRef(null);

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    c1: "1",
    c2: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    c1: "1"
  });
  const [shownCards2, setShownCards2] = useState({
    c2: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "hilo_virtual"
  });

  //console.log(data);
  const displayRunnerName = (runnerName) => {
    if (runnerName == "b1" || runnerName == "High") return "High";
    if (runnerName == "b2" || runnerName == "Low") return "Low";
    if (runnerName == "b3" || runnerName == "Snap") return "Snap";
    return runnerName || "";
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      //console.log("placeBetObject: ", placeBetObject);
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "hilo_virtual"
    });
    let books = res?.data;
    if (books !== null && books?.length > 0) {
      for (let i = 0; i < books?.length; i++) {
        let obj = books[i];
        setHighBook(obj.High);
        setLowBook(obj.Low);
        setSnapBook(obj.Snap);
      }
    }
  }

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  //console.log('data: ', data);
  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;

  // console.log("C1: ", payload?.c1);
  // console.log("C2: ", payload?.c2);
  // console.log("AC3: ", payload?.ac3);
  // console.log("BC1: ", payload?.bc1);
  // console.log("BC2: ", payload?.bc2);
  // console.log("BC3: ", payload?.bc3);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);

    updateUserData(data?.user);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setHighBook(0);
      setLowBook(0);
      setSnapBook(0);
      setWinnerHigh(false);
      setWinnerLow(false);
      setWinnerSnap(false);
    }

    if (payload?.result == 1) {
      setWinnerHigh(true);
      setWinnerLow(false);
      setWinnerSnap(false);
    } else if (payload?.result == 2) {
      setWinnerHigh(false);
      setWinnerLow(true);
      setWinnerSnap(false);
    } else if (payload?.result == 3) {
      setWinnerHigh(false);
      setWinnerLow(false);
      setWinnerSnap(true);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setB7Val(payload?.b7);
    setB8Val(payload?.b8);
    setB9Val(payload?.b9);
    setB10Val(payload?.b10);
    setB11Val(payload?.b11);
    setB12Val(payload?.b12);
    setB13Val(payload?.b13);

    setTimeLeft(serverSeconds);

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);
    setFlipStep(0);

    let step = 1;

    function run() {
      // Step 1 → Player A card
      if (step === 1) {
        setShownCards((prev) => ({
          ...prev,
          c1: payload?.c1
        }));
      }

      // Step 2 → Player B card
      if (step === 2) {
        setShownCards((prev) => ({
          ...prev,
          c2: payload?.c2
        }));
      }

      setFlipStep(step);
      step++;

      if (step <= 2) {
        flipTimerRef.current = setTimeout(run, 600);
      }
    }

    if (payload.evt_status === "CLOSED") {
      flipTimerRef.current = setTimeout(run, 300);
    }

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketType
  ) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "hilo_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;
    //console.log("teamname->", teamname);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    //placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;
    placeBetObject.market_type = marketType;

    setPlaceBetObject(placeBetObject);
    //console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit??data?.myBetLimit?.figure));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "hilo_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  useEffect(() => {
    document.documentElement.classList.add("cards-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("cards-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "hilo_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    shownCards && (
      <div className="aviator-scope player-scope cards-bg-black">
        <ClientLayoutWithOutHeader showLoader={false}>
          <div class="details-tabs-wrapper1">
            <div className="main-page">
              <div className="row no-gutters">
                <div className="col-md-12">
                  <div className="bodyheight">
                    <div className="wrapper">
                      <TPStudioSidebar open={open} />
                    </div>

                    <div className="lobby-ctn BPGmaindiv">
                      <TpStudioHeader setOpen={setOpen} open={open} />
                      <TpStudioLoader displayLoader={displayLoader} />
                    </div>

                    <div
                      className="row"
                      style={{ display: displayLoader ? "none" : "" }}
                    >
                      <div className="col-md-8">
                        <div className="left-content">
                          <div>
                            {" "}
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                              <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                <p>HILO</p>
                              </div>
                              <div
                                className="col-6 col-md-6 inline-block Gameidcol text-right"
                                style={{ marginTop: "4px" }}
                              >
                                <div
                                  role="group"
                                  aria-label="Second group"
                                  className="btn-group btn-group-sm mr-2"
                                >
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    id="Alltab"
                                    className={
                                      activeTabIndex == 1
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                    onClick={() => activeTab(1)}
                                  >
                                    Game
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    id="RESULTStab"
                                    className={
                                      activeTabIndex == 2
                                        ? "tablink btn btn-primary bbactive"
                                        : "tablink btn btn-primary"
                                    }
                                    onClick={() => activeTab(2)}
                                  >
                                    Results
                                  </button>
                                  <button
                                    style={{ fontSize: "14px" }}
                                    type="button"
                                    className="tablink btn btn-primary"
                                    onClick={() => setShowRules(true)}
                                  >
                                    Rules
                                  </button>
                                  <HiloRules
                                    show={showRules}
                                    onClose={() => setShowRules(false)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="cards-layout blackjack"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div>
                              <div
                                className="cards-layout blackjack"
                                style={{ height: "220px" }}
                              >
                                <div
                                  className="col-12 timerDiv2"
                                  style={{ paddingLeft: "0px" }}
                                >
                                  <div
                                    className="row mt-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <div className="col-2 col-md-1">
                                      <div
                                        className="Connectedclients mt-1"
                                        style={{ marginLeft: "20px" }}
                                      >
                                        <i
                                          aria-hidden="true"
                                          className="fa fa-user mr-1"
                                          style={{
                                            fontSize: "14px",
                                            color: "white"
                                          }}
                                        />
                                        <b>
                                          <span
                                            id="UsersCount"
                                            className="number"
                                          >
                                            326
                                          </span>
                                        </b>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="col-md-8"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  />

                                  <div
                                    className="col-md-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    {/* Timer with animated stroke + numeric countdown */}
                                    <div className="teenpatti-base-timer">
                                      <svg
                                        viewBox="0 0 100 100"
                                        className="base-timer__svg"
                                      >
                                        <g className="base-timer__circle">
                                          <circle
                                            cx="50"
                                            cy="50"
                                            r="45"
                                            className="base-timer__path-elapsed"
                                          />
                                          <path
                                            strokeDasharray={`${Math.round(
                                              dash
                                            )} ${Math.round(CIRC)}`}
                                            className={`base-timer__path-remaining ${timerColor}`}
                                            d="
                                              M 50, 50
                                              m -45, 0
                                              a 45,45 0 1,0 90,0
                                              a 45,45 0 1,0 -90,0
                                            "
                                          />
                                        </g>
                                      </svg>
                                      <span className="base-timer__label">
                                        {timeLeft == 1 ? 0 : timeLeft}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Players */}
                                <div
                                  className="table-player"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* PLAYER A */}
                                  <div
                                    className="player card32-player-item"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <span
                                      className="name"
                                      style={{ fontSize: "14px" }}
                                    >
                                      Joker
                                    </span>
                                    <div className="tp-hand">
                                      <div className="cards-tp-card">
                                        <img
                                          src={`/assets/images/cards/${
                                            payload?.c1 ? payload.c1 : "1"
                                          }.svg`}
                                          draggable={false}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* PLAYER B */}
                                  <div
                                    className="player card32-player-item"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <span
                                      className="name"
                                      style={{ fontSize: "14px" }}
                                    >
                                      ANTE
                                    </span>
                                    <div className="tp-hand">
                                      <div
                                        className={`cards-tp-card ${
                                          flipStep === 1 && payload?.c2 != "1"
                                            ? "flip"
                                            : ""
                                        }`}
                                      >
                                        <img
                                          src={`/assets/images/cards/${
                                            payload?.c2 ? payload.c2 : "1"
                                          }.svg`}
                                          draggable={false}
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    textAlign: "right",
                                    marginTop: "-28px",
                                    marginRight: "20px",
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <Volume />
                                </div>
                                {/* Controls removed (auto mode) */}
                              </div>
                            </div>
                          </div>

                          {/* Footer */}
                          <center
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer top">
                              <div className="buttons-div">
                                {Object.keys(resultList).map((idx) => (
                                  <button
                                    key={idx}
                                    className="video-button border-gradient-btn border-gradient-purple-btn"
                                  >
                                    {resultList[idx]}
                                  </button>
                                ))}
                              </div>
                              <div className="round-div">
                                <div className="label">Round ID:</div>
                                <div className="id">{payload?.cat_mid}</div>
                              </div>
                            </div>
                          </center>

                          {/* Market Sections (unchanged) */}
                          <div
                            className="bg-white"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div
                              className="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>MAIN </span>
                                    {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                  </span>
                                </p>
                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      winnerHigh && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b1Sucess"
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  High
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      highBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      highBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(highBook)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b1span"
                                      data-teamname="High"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "high",
                                          "high",
                                          b1Val,
                                          "m"
                                        )
                                      }
                                    >
                                      {b1Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      winnerSnap && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b3Sucess"
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Snap
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      snapBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      snapBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(snapBook)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b2span"
                                      data-teamname="Snap"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "snap",
                                          "snap",
                                          b3Val,
                                          "f"
                                        )
                                      }
                                    >
                                      {b3Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div className="runner-runner">
                                  <h3
                                    className={
                                      winnerLow && flipStep >= 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b2Sucess"
                                  >
                                    <div className="runner-info">
                                      <span className="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: 0,
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                  }}
                                                  className="clippable-spacer"
                                                >
                                                  Low
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      lowBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      lowBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(lowBook)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>
                                  <div className="price-row-box-new">
                                    {isSuspended && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a
                                      className="price-price price-back mb-show span1details"
                                      id="runner1b2span"
                                      data-teamname="Low"
                                      data-bettype="b"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "low",
                                          "low",
                                          b2Val,
                                          "m"
                                        )
                                      }
                                    >
                                      {b2Val}
                                      <span className="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </a>
                                    <a className="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                    <a className="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none",
                              color: "white"
                            }}
                          >
                            <HiLowResult resultData={resultData} />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        {showBetSlipPopup && (
                          <TPPopUpBetSlip
                            closeBetSlipParent={closeBetSlipMobile}
                            betObj={placeBetObject}
                            placeBetParent={placeBet}
                            betButtonShow={betButtonShow}
                            betErrorMessageObj={betErrorMessageObj}
                            betButtonShowLoaderShow={betButtonShowLoaderShow}
                            profileData={profileData}
                          />
                        )}
                        <TeenPattisCasinoBetslipWeb
                          showBetSlip={showBetSlip}
                          placeBetObject={placeBetObject}
                          closeBetSlipParent={closeBetSlip}
                          placeBetParent={placeBet}
                          betErrorMessageObj={betErrorMessageObj}
                          profileData={profileData}
                        ></TeenPattisCasinoBetslipWeb>
                        <div>
                          <div className="bets">
                            <strong>
                              Matched Bets (0)
                              <img
                                src={reconnecting}
                                alt="dc"
                                className="rounded disconnected"
                                style={{ display: "none" }}
                              />{" "}
                            </strong>
                            <div className="betting-table">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Runner</th>
                                    <th>Price</th>
                                    <th>Size</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {placedBets.map((bet, index) => {
                                    console.log("MATCHED BET:", bet);
                                    return (
                                      <tr
                                        key={index}
                                        style={{
                                          background:
                                            bet.type == "b"
                                              ? "#e9f6fc"
                                              : "#fce3e4"
                                        }}
                                      >
                                        <td>
                                          {displayRunnerName(bet.rnr)} - (
                                          {bet.cat_mid})
                                        </td>
                                        <td>{bet.amnt}</td>
                                        <td>{bet.rate}</td>
                                        <td></td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>
            {`
              @media (max-width: 768px) {
                .player-scope ul.top-nav,
                .player-scope .top-nav {
                  padding-left: 0 !important;
                }
              }
              .player-scope .tp-hand {
                position: relative;
                width: 200px;
                height: 100px;
                margin: 10px -10px;
                overflow: visible;
                border-radius: 12px;
                border: 1px solid rgba(178, 220, 175, 0.25);
                display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
              }
              .table-player{
                gap: 0!important;
                margin-top: -12px !important;
              }
              .player-scope .table-player .player {
                width: 211px;
              }
              .cards-tp-card {
                margin-top: 6px;
                width: 50px;
              }
              .footer-divbpg,
              .table-player,
              .bg-white {
                margin-left: 12px;
              }
              @media (max-width:576px){
                .footer-divbpg{
                  margin-left: 1px !important;
                }
                .col-md-4{
                  padding-top: 10px;
                }
                .col-md-8{
                  padding-left: 10px !important;
                  padding-right: 10px !important;
                }
                .player-scope .cards-layout.blackjack {
                  height: 220px;
                  background: radial-gradient(
                    ellipse 160% 45% at 50% calc(52% - 15px),
                    rgba(18, 105, 45, 0.42) 0%,
                    rgba(10, 70, 30, 0.35) 22%,
                    rgba(0, 0, 0, 0.9) 58%,
                    #000000 100%
                  );
                }
                .player-scope .tp-hand {
                  width: 145px;
                  height: 60px;
                }
                .player-scope .table-player .player {
                  width: 155px;
                }
                .cards-tp-card img{
                  height: 48px;
                }
                .row{
                  padding-left: 5px;
                  padding-right: 5px;
                }
                .top{
                  margin-top: -15px;
                }
              }
            `}
          </style>
        </ClientLayoutWithOutHeader>
      </div>
    )
  );
}
